import {
  SearchSelectionRenderer,
  TextFieldRenderer,
  type TextFieldRendererProps,
  type SearchSelectionRendererProps,
  getRendererProps,
} from '@exam-center/components';
import { Flex, Grid, Text } from '@shared/components';

export interface EmployeeInformationFieldsProps {
  fields: {
    blockedType: SearchSelectionRendererProps;
    position?: TextFieldRendererProps;
    department?: TextFieldRendererProps;
  };
  visibleFields?: {
    position?: boolean;
    department?: boolean;
  };
}

export default function EmployeeInformationFields(props: Readonly<EmployeeInformationFieldsProps>) {
  const { fields, visibleFields } = props;

  const canDisplayInfo = !!visibleFields?.position || !!visibleFields?.department;

  return (
    <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(6) })}>
      <Grid
        sx={(theme) => ({
          gridTemplateColumns: '240px 1fr',
          gap: theme.spacing(6),
        })}
      >
        <Text variant='body1Semibold'>ประเภทผู้ไม่มีสิทธิ์สอบ</Text>
        <SearchSelectionRenderer
          {...getRendererProps(fields.blockedType, {
            label: 'ประเภทหน้าที่',
            placeholder: 'เลือกประเภทหน้าที่',
            sx: {
              maxWidth: '600px',
            },
          })}
        />
        {canDisplayInfo ? (
          <>
            <Text variant='body1Semibold'>ข้อมูลการปฏิบัติหน้าที่</Text>
            <Flex sx={(theme) => ({ gap: theme.spacing(4) })}>
              {fields.position ? (
                <TextFieldRenderer
                  {...getRendererProps(fields.position, {
                    label: 'ตำแหน่ง',
                    placeholder: 'กรอกตำแหน่ง',
                  })}
                />
              ) : null}

              {fields.department ? (
                <TextFieldRenderer
                  {...getRendererProps(fields.department, {
                    label: 'ฝ่ายงาน/ส่วนงาน',
                    placeholder: 'กรอกฝ่ายงาน/ส่วนงาน',
                  })}
                />
              ) : null}
            </Flex>
          </>
        ) : null}
      </Grid>
    </Flex>
  );
}
